import { ODataObject } from '../../interfaces/odata-model.interface';
import { CompositeModel } from '../complex/composite.model';
import { TextModel } from '../primitive/text.model';

export interface JsonMaterialIdentifierModel {
    materialNumber: string;
    orderNumber: string;
    orderPosition: string;
}

export interface ODataMaterialIdentifierOutModel extends ODataObject {
    NewMaterial: string;
    PONumber: string;
    POItemNumber: string;
}

export class MaterialIdentifierModel extends CompositeModel {
    public materialNumber: TextModel;
    public orderNumber: TextModel;
    public orderPosition: TextModel;
    public constructor(materialNo: string, orderNo: string, orderPos: string) {
        super('MaterialIdentifierModel');

        this.materialNumber = <TextModel>this.set(new TextModel('NewMaterial', materialNo));
        this.orderNumber = <TextModel>this.set(new TextModel('PONumber', orderNo));
        this.orderPosition = <TextModel>this.set(new TextModel('POItemNumber', orderPos));
    }

    public getOutModel(): ODataMaterialIdentifierOutModel {
        return <ODataMaterialIdentifierOutModel>super.getOutModel();
    }

    public toString(): string {
        return `${this.materialNumber.value}:${this.orderNumber.value}:${this.orderPosition.value}`;
    }

    public static compare(
        firstIdentifier: MaterialIdentifierModel,
        secondIdentifier: MaterialIdentifierModel,
    ): boolean {
        return (
            firstIdentifier.materialNumber.value === secondIdentifier.materialNumber.value &&
            firstIdentifier.orderNumber.value === secondIdentifier.orderNumber.value &&
            firstIdentifier.orderPosition.value === secondIdentifier.orderPosition.value
        );
    }

    public toJSON(): JsonMaterialIdentifierModel {
        return {
            materialNumber: this.materialNumber.value,
            orderNumber: this.orderNumber.value,
            orderPosition: this.orderPosition.value,
        };
    }
}
export class MaterialIdentifierModelFromJson extends MaterialIdentifierModel {
    public constructor(data: JsonMaterialIdentifierModel) {
        super(data.materialNumber, data.orderNumber, data.orderPosition);
    }
}
